import { createAction } from '@reduxjs/toolkit'
import { IBreadCrumb } from 'kyc-core/dist/Interfaces'
import { IFormData, IFolderContent } from '../interfaces/Folder'

export const initialDataReceived = createAction<
  [IFolderContent, IBreadCrumb[]]
>('INITIAL_DATA_RECEIVED')

export const initialDataLoading = createAction('INITIAL_DATA_LOADING')

export const initialDataFailed = createAction<Error>('INITIAL_DATA_FAILED')

export const folderSaved = createAction<IFormData>('FOLDER_SAVED')
